import * as React from "react";

const RightArrowNew = ({ stroke = "#FFF" }) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="20"
    height="16"
    fill="none"
    viewBox="0 0 19 16"
  >
    <g stroke={stroke} strokeLinecap="round" strokeWidth="1.5">
      <path
        d="M1 7.92h17M11.271 1.272 17.86 7.86M11.271 14.45l6.589-6.59"
      ></path>
    </g>
  </svg>
);

export default RightArrowNew;
